import { ESdChangeReason } from "@kuika/kuika-cl-model";
import classNames from "classnames";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import { KMainFunctions } from "../../../shared/utility/main-functions";

export interface IKuikaSpinnerState {}

export interface IKuikaSpinnerProps {
  className?: string;
}

class KuikaSpinner extends PureSdComponent<IKuikaSpinnerProps & IWithSDProps, IKuikaSpinnerState> {
  constructor(props: IKuikaSpinnerProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  render() {
    const isMainAi = KMainFunctions.isMainAI();
    if (isMainAi) {
      return (
        <video
          className={classNames("spinner", this.props.className)}
          src="/assets/main-ai/spinner.webm"
          style={{ width: "250px", height: "250px" }}
          playsInline
          autoPlay
          muted
          loop
        />
      );
    }

    return (
      <div
        className={classNames("spinner", "kuika-logo-spinner-wrapper", this.props.className)}
        role="img"
        aria-label="Loading"
      >
        <div className="kuika-logo-spinner-rect" aria-hidden="true" />
        <img
          className="kuika-logo-spinner-logo"
          src="/images/common/kuika-logo-inside.svg"
          alt=""
          width={160}
          height={160}
        />
      </div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const kuikaSpinner = withSD<IKuikaSpinnerProps>(KuikaSpinner);
export { kuikaSpinner as KuikaSpinner };
